import React from 'react';
import { Spinner } from 'react-bootstrap';

interface AiLoaderProps {
    loadingText?: string;
    className?: string;
    style?: React.CSSProperties;
}

const AiLoader: React.FC<AiLoaderProps> = ({
    loadingText = "Processing and generating insights — please wait…",
    className,
    style,
}) => {
    return (
        <div
            className={`fade-in-animation ai-loader-container ${className || ''}`}
            style={{
                position: 'absolute',
                top: "0",
                left: "0",
                height: '100%',
                width: '100%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                flexDirection: 'column',
                background: '#ffffffe8',
                padding: "1rem",
                gap: ".5rem",
                ...style,
            }}
        >
            <div className="grid-loader">
                <div className="cube"></div>
                <div className="cube"></div>
                <div className="cube"></div>
                <div className="cube"></div>
                <div className="cube"></div>
                <div className="cube"></div>
                <div className="cube"></div>
                <div className="cube"></div>
                <div className="cube"></div>
            </div>

            {loadingText && <div className="text-center text-muted fw-bold text-small ">{loadingText}</div>}
        </div>
    );
};

export default AiLoader;
